
// Class Definition
import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
  } from 'chart.js';
  
  Chart.register(
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
  );



//https://github.com/corejavascript/typeahead.js
var weatherForecast = function() {
    var graph = function() {
        const ctx = document.getElementById('myChart');
        if(ctx){
          const myChart = new Chart(ctx, dataJson);
        }

    }

    var carrossel = function() {
        $(".slider").slick({
            slidesToShow: 8,
            slidesToScroll:4,
            dots: true,
            responsive: [{
          
                breakpoint: 1900,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll:3,
                }
          
              },{
          
                breakpoint: 1580,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll:2,
                }
          
              },{
          
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll:2,
                  dots: false,
                }
          
              }, {
          
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll:1,
                  dots: false,
                }
          
              }]
          });

    }
   

    var autocomplete = function(){
      
      $('.typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 3,
      },
      {
        name: 'name',
        display: function(data){
          return data.name + ' - ' + data.state.uf;
        },
        displayKey: 'name',
        source: function (query, syncResults, asyncResults) {
          apiClient.head('/sanctum/csrf-cookie')
          .then(response => {
              apiClient.post('/autocomplete/city', {query: query}).then(response => {
                  return asyncResults(response.data);
              }).catch(function (error) {
                  return asyncResults(response.data);
              });
          }).catch(function (error) {
              return asyncResults(response.data);
          });

        },

        templates: {
          suggestion: function(data){
            return '<p>' + data.name + ' - ' + data.state.uf + '</p>';
          }
        }

      });

      $('.typeahead').bind('typeahead:select', function(ev, data) {
        window.location = baseURL + '/clima-tempo/previsao-do-tempo/' + data.slug;
      });

    }

    return {
        init: function() {
            carrossel();
            graph();
            autocomplete();
        }
    };
}();

// Class Initialization
$(function(){
    weatherForecast.init();
    
    
});